// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"styles__notFoundContainer___3PYay","notFoundIcon":"styles__notFoundIcon___1RSX0","icon":"styles__icon___EAtcH"};